<div class="gcontainer bwhite">
  <div class="row">
    <div class="col-md-11">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active breadcrumb cursor"
            aria-current="page"
            (click)="reDirectUrl()"
            (keypress)="reDirectUrl()"
            tabindex="0">
            Dashboard
          </li>
          <li class="breadcrumb-item active" aria-current="page">Companies Management</li>
        </ol>
      </nav>
    </div>
    <h1>Companies Management</h1>

    <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" class="mat-table" multiTemplateDataRows>
            <ng-container matColumnDef="companyNumber">
                <th mat-header-cell *matHeaderCellDef> Number </th>
                <td mat-cell *matCellDef="let company"> {{ company.companyNumber }} </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let company"> {{ company.name }} </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>
              <td mat-cell *matCellDef="let company" class="text-center">
                  <button
                      mat-icon-button
                      color="warn"
                      (click)="deleteCompany(company)"
                      matTooltip="Delete Company">
                      <mat-icon>delete</mat-icon>
                  </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
  </div>
</div>